var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "50%",
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-form-inline",
          attrs: {
            model: _vm.formInfo,
            rules: _vm.rules,
            inline: false,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商户名称", prop: "merchantName" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.formInfo.merchantName,
                  callback: function ($$v) {
                    _vm.$set(_vm.formInfo, "merchantName", $$v)
                  },
                  expression: "formInfo.merchantName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "status" } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "正常" },
                  model: {
                    value: _vm.formInfo.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInfo, "status", $$v)
                    },
                    expression: "formInfo.status",
                  },
                },
                [_vm._v("正常")]
              ),
              _c(
                "el-radio",
                {
                  attrs: { label: "禁用" },
                  model: {
                    value: _vm.formInfo.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInfo, "status", $$v)
                    },
                    expression: "formInfo.status",
                  },
                },
                [_vm._v("禁用")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm")
                    },
                  },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }